module.exports = __webpack_public_path__ + "890a9726d25f876937438ee361ca8146.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/modals/add.svg
// module id = 1028
// module chunks = 0